<form [formGroup]="nestedForm">
  <div formArrayName="forms">
    @for (form of forms?.controls; track form; let formIndex = $index) {
      <ng-container
        [formGroupName]="formIndex">
        <tidy-alert @slideFromTop>
          <form [formGroup]="form">
            @for (field of form?.controls; track field; let fieldIndex = $index; let lastField = $last) {
              <ng-container
                [formGroupName]="fieldIndex">
                <div @slideFromTop class="animated-div">
                  <div class="field-header-container">
                    <div>
                      @if (formIndex === 0) {
                        <tidy-text
                        [header]="fieldIndex === 0 ? 'Only continue if' : 'And'" />
                      }
                      @if (formIndex > 0) {
                        <tidy-text
                        [header]="fieldIndex === 0 ? 'Or continue if' : 'And'" />
                      }
                    </div>
                    <div>
                      <!-- INFO: Avoid to use tidy-button here because it has a bug -->
                      @if (fieldIndex === 0) {
                        <div (click)="removeForm(formIndex)" class="remove-rule-group-div">
                          <img src="assets/icon/trash-white.png" alt="Trash">
                          <tidy-text [body]="'Remove Rule Group'" />
                        </div>
                      } @else {
                        <div (click)="removeField(form, formIndex, fieldIndex)" class="remove-rule-group-div">
                          <img src="assets/icon/trash-white.png" alt="Trash">
                          <tidy-text [body]="'Remove Rule'" />
                        </div>
                      }
                    </div>
                  </div>
                  <ion-row>
                    @for (operatorField of operatorFields; track operatorField; let operatorFieldIndex = $index) {
                      @if (operatorFieldIndex === formIndex) {
                        @for (operatorFieldItem of operatorField; track operatorFieldItem; let i = $index) {
                          @if (i === fieldIndex) {
                            @for (item of operatorFieldItem; track item) {
                              @if (item?.type === 'select') {
                                <tidy-select
                                  [icon]="'assets/svg/list.svg'"
                                  [label]="item?.label"
                                  [items]="item?.items"
                                  [multiple]="item?.multiple"
                                  [form]="field?.get(item?.formControlName)"
                                  [formControlName]="item?.formControlName"
                                  (optionChange)="onSelectChanges($event, field, formIndex, fieldIndex, item)" />
                              }
                              @if (item?.type === 'number') {
                                <ion-col>
                                  <tidy-input
                                    [icon]="'assets/svg/information-circle.svg'"
                                    [formControlName]="item?.formControlName"
                                    [form]="field?.get(item?.formControlName)"
                                    [label]="item?.label"
                                    [type]="item?.type || 'text'"
                                    [errorMessage]="'Please enter a valid value'" />
                                </ion-col>
                              }
                              @if (item?.type === 'text' || item?.type === 'dateText') {
                                <div class="chip-text-area-container">
                                  <tidy-chip-text-area
                                    [id]="item?.id"
                                    [inputKey]="item?.formControlName"
                                    [inputTitle]="item?.label"
                                    [isRequired]="item?.required"
                                    (inputChange)="onInputChange($event, field)"
                                    (inputFocusIn)="setSelectedChipTextArea(item?.id)"
                                    (onInit)="onChipTextAreaInit(item?.id, field?.get(item?.formControlName))" />
                                  <div class="chip-container">
                                    @for (chip of chips; track chip) {
                                      <ion-chip (click)="addChipPlaceholder(chip, item?.id)">
                                        <strong>+<span>&nbsp;</span></strong> {{ chip.text }}
                                      </ion-chip>
                                    }
                                  </div>
                                  @if (item?.type === 'dateText') {
                                    <tidy-button
                                      [text]="'Switch to custom date'"
                                      [smallText]="true"
                                      class="primary form-action-button"
                                      [type]="'button'"
                                      [action]="switchToCustomDate.bind(this, field, item)" />
                                  }
                                </div>
                              }
                              @if (item?.type === 'date') {
                                <ion-col>
                                  <tidy-datepicker
                                    [formControlName]="item?.formControlName"
                                    [form]="field?.get(item?.formControlName)"
                                    [label]="item?.label"
                                    [icon]="'assets/svg/calendar.svg'"
                                    [errorMessage]="'Please enter a valid date.'" />
                                  <tidy-button
                                    [text]="'Switch to custom date'"
                                    [smallText]="true"
                                    class="primary form-action-button"
                                    [type]="'button'"
                                    [action]="switchToCustomDate.bind(this, field, item)" />
                                </ion-col>
                              }
                              @if (item?.type === 'customDate') {
                                <ion-col>
                                  <tidy-daterange
                                    class="daterange-custom-input"
                                    [label]="item?.label"
                                    (stringDateOption)="selectStringDateRange($event, field, item)"
                                    [(dateRangeForm)]="item.dateRangeForm"
                                    [selectOptions]="item?.selectOptions"
                                    [rangeOption]="true"
                                    [icon]="'assets/svg/calendar.svg'"
                                    [appearance]="'outline'"
                                    [errorMessage]="'Please enter a valid date.'" />
                                </ion-col>
                              }
                              @if (item.type === 'money') {
                                <ion-col>
                                  <tidy-input
                                    [icon]="'assets/svg/cash.svg'"
                                    [formControlName]="item?.formControlName"
                                    [form]="field?.get(item?.formControlName)"
                                    [label]="item?.label"
                                    [mask]="'currencyMask'"
                                    [errorMessage]="'Please enter a valid value'" />
                                </ion-col>
                              }
                            }
                          }
                        }
                      }
                    }
                  </ion-row>
                  @if (lastField) {
                    <ion-row>
                      <div style="padding-left: 6px">
                        <tidy-button
                          [text]="'And'"
                          [smallText]="true"
                          class="primary form-action-button"
                          [type]="'button'"
                          [image]="'assets/img/add-white.svg'"
                          [action]="addNestedField.bind(this, form, formIndex)" />
                      </div>
                    </ion-row>
                  }
                </div>
              </ng-container>
            }
          </form>
        </tidy-alert>
      </ng-container>
    }
  </div>
  <ion-row class="add-form-row animated-div" @slideFromTop>
    <div>
      <tidy-button
        text="Add 'Or' rule group"
        [smallText]="true"
        class="primary form-action-button"
        [type]="'button'"
        [image]="'assets/img/add-white.svg'"
        [action]="boundAddNestedForm" />
    </div>
  </ion-row>
</form>
